const atualizarLimites = (state, limites) => {
    state.limites = limites;
}

const atualizarLimite = (state, limite) => {
    state.limite = limite;
}

const atualizarUsuariosLimite = (state, usuariosLimite) => {
    state.usuariosLimite = usuariosLimite;
}

export default {
    atualizarLimites,
    atualizarLimite,
    atualizarUsuariosLimite
}